import { Injectable } from '@angular/core';
import { PersonalLoanApplicationDisclosureApi } from '../../../../../../generated/internalApi';
import { ApiService } from '@app/shared/services/api.service';
import { SessionService } from '@app/shared/services';
import { Observable } from 'rxjs/Observable';
import { AppConfigDisclosures, AppConfigResponse, DocumentTemplate } from '@app/shared/models';

@Injectable()
export class LoanApplicationDisclosureService extends ApiService {
  constructor(
    private disclosureApi: PersonalLoanApplicationDisclosureApi,
    protected sessionService: SessionService) {

    super(sessionService);
  }

  public getDisclosureDocument(templateName: string): Observable<DocumentTemplate> {
    return this.disclosureApi.personalLoanApplicationDisclosureGetTemplateByTemplateName(
      templateName,
      this.authToken
    )
    .map(res => res.data);
  }

  public getDisclosures(): Observable<AppConfigDisclosures> {
    let result: Observable<AppConfigResponse>;

    if (this.plData.loanApplicationGuid) {
      result = this.disclosureApi.personalLoanApplicationDisclosureGetDisclosuresByLoanApplicationGuid(
        this.plData.loanApplicationGuid,
        this.authToken
      );
    } else {
      result = this.disclosureApi.personalLoanApplicationDisclosureGetDisclosures(
        this.authToken
      );
    }

    return result.map(res => res.data.disclosuresList).catch(this.apiErrorHandler);
  }
}
